var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 200,
    viewBox: "0 0 218 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_2589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14478 49.4665V144.112C1.14478 146.054 2.18294 147.861 3.87476 148.822L83.1019 194.578C84.7937 195.559 86.87 195.559 88.5426 194.578L167.77 148.822C169.462 147.842 170.5 146.054 170.5 144.112V49.4665L85.8127 98.3562L1.14478 49.4665Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14502 49.4667L85.8321 0.576904L170.519 49.4667L85.8321 98.3756L1.14502 49.4667Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8469 68.3649L118.515 19.4752L137.586 30.4912L52.8991 79.4002L52.8606 116.005L33.8276 105.027L33.8469 68.3649Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.832 98.3755V194.848",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6047 158.935V175.103L44.4785 157.974V141.805L73.6047 158.935Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.288 200C196.568 200 217.871 178.697 217.871 152.418C217.871 126.139 196.568 104.835 170.288 104.835C144.009 104.835 122.706 126.139 122.706 152.418C122.706 178.697 144.009 200 170.288 200Z",
    fill: "#41B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.829 167.613C177.231 167.613 184.852 159.991 184.852 150.589C184.852 141.187 177.231 133.566 167.829 133.566C158.428 133.566 150.806 141.187 150.806 150.589C150.806 159.991 158.428 167.613 167.829 167.613Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.099 171.86L179.833 162.611",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_2589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217.303,
    height: 200,
    fill: "white",
    transform: "translate(0.568115)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection);
export default __webpack_public_path__ + "static/media/inspection.b52441f35c8a5cbae70b53ce8b9799c2.svg";
export { ForwardRef as ReactComponent };